import { useState } from 'react';

export default function ProductCategories() {
  const [selectedBrand, setSelectedBrand] = useState('Fiat Abarth');

  const brands = [
    {
      name: 'Fiat Abarth',
      fullName: 'Fiat 500 Abarth',
      models: ['500 Abarth 595', '500 Abarth 695', '500 Abarth 695 Biposto', '500 Abarth 695 XSR'],
      categories: ['Front Splitters', 'Side Skirts', 'Rear Diffusers', 'Spoilers', 'Mirror Caps', 'Interior Trim'],
      image: '/images/fiat 500 abarth/IMG_2922.jpeg',
    },
    {
      name: 'Mercedes G',
      fullName: 'Mercedes G-Klasa',
      models: ['G 500', 'G 63 AMG', 'G 350 d', 'G 400 d', 'G 63 AMG Edition 1'],
      categories: ['Aero Kits', 'Front Splitters', 'Mirror Caps', 'Side Steps', 'Hood Accents', 'Interior Panels'],
      image: '/images/g klasa/IMG_5172.JPG',
    },
    {
      name: 'Aventador',
      fullName: 'Lamborghini Aventador',
      models: ['Aventador LP700-4', 'Aventador S', 'Aventador SVJ', 'Aventador Ultimae'],
      categories: ['Aero Packages', 'Rear Wings', 'Side Blades', 'Diffusers', 'Engine Covers', 'Interior Carbon'],
      image: '/images/aventador/4295e49e-8a17-468e-bf21-f13813a1b316.jpg',
    },
    {
      name: 'Porsche',
      fullName: 'Porsche',
      models: ['911 GT3 / GT3 RS', '911 Turbo S', 'Cayman GT4', '718 Boxster S'],
      categories: ['Aero Packages', 'Rear Wings', 'Front Lips', 'Side Skirts', 'Engine Covers', 'Interior Carbon'],
      image: '/images/porsche/IMG_9627.JPG',
    },
    {
      name: 'Mégane 4',
      fullName: 'Renault Mégane 4 RS',
      models: ['Mégane RS 280', 'Mégane RS 300 Trophy', 'Mégane RS Trophy-R', 'Mégane R.S. EDC'],
      categories: ['Front Splitters', 'Side Skirts', 'Rear Diffusers', 'Spoilers', 'Mirror Caps', 'Interior Trim'],
      image: '/images/megan 4/IMG_1604.JPG',
    },
    {
      name: 'Mégane 3',
      fullName: 'Renault Mégane 3 RS',
      models: ['Mégane RS 250', 'Mégane RS 265', 'Mégane RS 275 Trophy', 'Mégane RS 275 Trophy-R'],
      categories: ['Front Splitters', 'Side Skirts', 'Rear Diffusers', 'Spoilers', 'Mirror Caps', 'Interior Trim'],
      image: '/images/megan 3/IMG_1643.JPG',
    },
  ];

  const currentBrand = brands.find(b => b.name === selectedBrand) || brands[0];

  return (
    <section id="products" className="bg-white py-16 md:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8">
        {/* Section Header */}
        <div className="mb-10 md:mb-16 text-center">
          <div className="flex items-center justify-center gap-4 mb-4 md:mb-6">
            <div className="w-10 md:w-16 h-[2px] bg-gradient-to-r from-transparent via-black to-transparent"></div>
            <span className="text-gray-500 text-xs uppercase tracking-[3px] md:tracking-[4px] font-bold">
              PRECISION ENGINEERED
            </span>
            <div className="w-10 md:w-16 h-[2px] bg-gradient-to-r from-transparent via-black to-transparent"></div>
          </div>
          <h2 className="text-black text-4xl sm:text-5xl md:text-7xl font-black tracking-tighter leading-[1.1] mb-4 md:mb-6">
            SHOP BY BRAND
          </h2>
          <p className="text-gray-600 text-base md:text-xl max-w-3xl mx-auto">
            Carbon fiber komponente izrađene za svaki model — savršen fitment i maksimalni performance gains.
          </p>
        </div>

        {/* Brand Selector Tabs */}
        <div className="flex items-center justify-center gap-2 md:gap-3 mb-10 md:mb-20 flex-wrap">
          {brands.map((brand) => (
            <button
              key={brand.name}
              onClick={() => setSelectedBrand(brand.name)}
              className={`px-5 md:px-10 py-3 md:py-4 text-xs md:text-base font-bold uppercase tracking-wider transition-all whitespace-nowrap cursor-pointer ${
                selectedBrand === brand.name
                  ? 'bg-black text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {brand.name}
            </button>
          ))}
        </div>

        {/* Brand Content - Split Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 mb-16 md:mb-32 items-center">
          {/* Left Side - Brand Info */}
          <div className="space-y-6 md:space-y-8">
            <div>
              <h3 className="text-black text-3xl sm:text-4xl md:text-6xl font-black tracking-tighter leading-[1.1] mb-3 md:mb-6">
                {currentBrand.fullName}
              </h3>
              <p className="text-gray-600 text-base md:text-lg mb-4 md:mb-8">
                Precision-engineered carbon fiber components designed specifically for your model.
              </p>
            </div>

            {/* Model List */}
            <div>
              <h4 className="text-black text-xs uppercase tracking-[3px] font-bold mb-3 md:mb-4">
                COMPATIBLE MODELS
              </h4>
              <div className="grid grid-cols-2 gap-2 md:gap-3">
                {currentBrand.models.map((model, index) => (
                  <div
                    key={index}
                    className="bg-gray-50 px-3 md:px-4 py-2 md:py-3 text-gray-700 text-xs md:text-sm font-semibold border-l-2 border-black"
                  >
                    {model}
                  </div>
                ))}
              </div>
            </div>

            {/* Part Categories as Pills */}
            <div>
              <h4 className="text-black text-xs uppercase tracking-[3px] font-bold mb-3 md:mb-4">
                PART CATEGORIES
              </h4>
              <div className="flex flex-wrap gap-2 md:gap-3">
                {currentBrand.categories.map((category, index) => (
                  <span
                    key={index}
                    className="px-3 md:px-5 py-1.5 md:py-2 bg-white border border-gray-300 text-gray-700 text-xs md:text-sm font-medium hover:border-black hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
                  >
                    {category}
                  </span>
                ))}
              </div>
            </div>

            {/* CTA Button */}
            <div className="pt-2 md:pt-4">
              <button className="bg-black px-8 md:px-12 py-4 md:py-5 text-white text-sm md:text-base font-bold uppercase tracking-wider hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer group flex items-center gap-3 w-full sm:w-auto justify-center sm:justify-start">
                SHOP {currentBrand.name} PARTS
                <i className="ri-arrow-right-line text-lg md:text-xl group-hover:translate-x-2 transition-transform"></i>
              </button>
            </div>
          </div>

          {/* Right Side - Product Image */}
          <div className="relative group order-first lg:order-last">
            <div className="relative bg-gray-50 p-6 md:p-12 overflow-hidden">
              <div className="w-full h-[280px] sm:h-[380px] md:h-[600px] flex items-center justify-center">
                <img
                  src={currentBrand.image}
                  alt={currentBrand.fullName}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-0 h-0 border-t-[40px] md:border-t-[60px] border-t-black border-l-[40px] md:border-l-[60px] border-l-transparent"></div>
              <div className="absolute bottom-0 left-0 w-0 h-0 border-b-[40px] md:border-b-[60px] border-b-black border-r-[40px] md:border-r-[60px] border-r-transparent"></div>
            </div>
          </div>
        </div>

        {/* Feature Strip - 3 Columns */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-8">
          <div className="relative group bg-gray-50 p-6 md:p-10 border-t-4 border-black">
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-black mb-4 md:mb-6">
              <i className="ri-scan-line text-white text-2xl md:text-3xl"></i>
            </div>
            <h3 className="text-black text-xl md:text-2xl font-black mb-3 md:mb-4 uppercase tracking-tight">
              OEM Fitment
            </h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              3D-scanned precision engineering ensures perfect fitment without modifications. Every component is designed using CAD data from original equipment specifications.
            </p>
          </div>

          <div className="relative group bg-gray-50 p-6 md:p-10 border-t-4 border-black">
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-black mb-4 md:mb-6">
              <i className="ri-temp-cold-line text-white text-2xl md:text-3xl"></i>
            </div>
            <h3 className="text-black text-xl md:text-2xl font-black mb-3 md:mb-4 uppercase tracking-tight">
              Autoclave Cured
            </h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              Aerospace-grade carbon fiber processed in high-pressure autoclaves at 6 bar and 135°C. This ensures maximum strength-to-weight ratio and flawless surface finish.
            </p>
          </div>

          <div className="relative group bg-gray-50 p-6 md:p-10 border-t-4 border-black">
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-black mb-4 md:mb-6">
              <i className="ri-flag-line text-white text-2xl md:text-3xl"></i>
            </div>
            <h3 className="text-black text-xl md:text-2xl font-black mb-3 md:mb-4 uppercase tracking-tight">
              Track Proven
            </h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              Tested on professional race circuits including Nürburgring and validated by motorsport teams. Performance and durability you can trust at any speed.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
